module.exports = __webpack_public_path__ + "static/img/banner.39b1539.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/scan/banner.jpg
// module id = QHiQ
// module chunks = 1